// extracted by mini-css-extract-plugin
module.exports = {"Table":"Roles_Table__3iQwd"};